// Must match the viewport meta in src/index.html, which every route starts from.
export const DEFAULT_VIEWPORT = 'width=device-width, initial-scale=1.0';

// The signing page keeps saved fields under 16px, where iOS zooms on focus. maximum-scale stops that zoom, and iOS still allows pinch.
export const SIGNING_PAGE_VIEWPORT = `${DEFAULT_VIEWPORT}, maximum-scale=1.0`;
